export default "__VITE_ASSET__Cj4IRgP9__"